import coinbaseLogo from "@/assets/coinbase-logo.jpg";
import silicoreLogo from "@/assets/silicore-logo.jpg";
import kbcryptoLogo from "@/assets/kbcrypto-logo.jpg";
import arbLogo from "@/assets/arb-logo.jpg";
import creatrifyLogo from "@/assets/creatrify-logo.jpg";

export const experiences = [
  {
    title: "Associate Product Manager Intern",
    company: "Coinbase",
    location: "San Francisco, CA",
    date: "Jun - Aug 2025",
    logo: coinbaseLogo,
    highlights: [
      "Led in-app communications for DEX launch to 30M users, collaborating with legal, marketing, design, and product; achieved 97% CTR on notifications and 54% engagement with custom FSTO",
      "Built and launched an Amplitude dashboard replacing Superset/Datadog tools, tracking funnels from announcement card → FSTO → DEX buy; adopted by eng, design, and product for launch monitoring",
      "Drove depreciation of legacy Web3 Wallet, creating FSTO and coordinating FSTO ramp from 1%→10%→100%, resulting in deprecation of 45% of users and 62% of HNWIs",
    ],
    skills: ["Product Management", "Blockchain", "Wrapped Assets", "Data Analytics"],
    url: "https://www.coinbase.com/trade-crypto/dex",
  },
  {
    title: "Founder",
    company: "KBCrypto",
    location: "Madrid, SP",
    date: "Feb - Apr 2025",
    logo: kbcryptoLogo,
    highlights: [
      "Educated high-net-worth individuals on blockchain & crypto concepts generating $10,000+ in revenue",
      "Optimized SEO through internal links and site structure integrating Google Tag Manager to tack users and personalize content",
      "Led marketing campaign including weekly LinkedIn posts and website articles resulting in 1,000+ monthly website viewers",
    ],
    skills: ["Liquidity Pools", "Yield Farming", "Marketing", "Client Sourcing"],
    url: "https://kbcrypto.io",
  },
    {
    title: "Co-Founder & Product Manager",
    company: "Silicore.io",
    location: "Ithaca, NY",
    date: "Jun 2024 - Feb 2025",
    logo: silicoreLogo,
    highlights: [
      "Secured $32,000 in funding for Silicore after successful pitch to Stellar Community Fund",
      "Developed go-to-market strategy, pricing model, technical architecture, and user journeys",
      "Selected as a speaker for Stellar’s main conference Meridian 2024 in London",
    ],
    skills: ["Product Strategy", "Blockchain", "Crypto Exchanges", "Hiring"],
    url: "https://silicore.io",
  },
  {
    title: "Finance & Data Analytics Intern",
    company: "ARB Interactive",
    location: "Miami, FL",
    date: "May - Aug 2024",
    logo: arbLogo,
    highlights: [
      "Built SQL dashboard in Metabase for financial KPIs with automated daily & weekly emails to CFO",
      "Wrote 30+ SQL queries on Metabase for all teams across the company leading to 22% increase in company Metabase traffic",
      "Optimized frontend structure switching from file-type to feature-based folder grouping reducing onboarding time by 40%",
      "Mapped competitors, sourced acquisition targets, and compiled EBITDA multiples, driving six-figure gaming acquisition",
    ],
    skills: ["SQL", "Python", "Typescript", "React", "Excel"],
    url: "https://arbinteractive.com",
  },
  {
    title: "Software Engineering Intern",
    company: "Creatrify",
    location: "Remote",
    date: "Jun - Aug 2022",
    logo: creatrifyLogo,
    highlights: [
      "Leveraged SQL, C#, and AngularJS to enhance follower experience developing feature for accessing purchased digital goods",
      "Programmed Digital Goods search feature and boosted speed by 24x by reducing application program interface (API) calls",
      "Implemented search bar allowing users to efficiently locate specific creators within the platform",
    ],
    skills: ["AngularJS", "C#", "ASP.NET", "SQL", "Stored Procedures"],
    url: "https://creatrify.com",
  },
];
